<template>
  <div>{{_content}}</div>
</template>

<script>
export default {
  methods: {
    $_getItemByValue(value) {
      const item = this.items.find(e => {
        return e.value == value;
      });
      return item;
    }
  },
  computed: {
    _content() {
      if (this.value == undefined) {
        return null;
      } else if ( typeof this.value === 'object' && this.value.text) {
        return this.value.text;
      } else if (!this.items.length) {
        return null;
      } else {
        return this.$_getItemByValue(this.value).text;
      }
    }
  },
  props: {
    value: {
      type: [Number, String, Array, Object],
      default: null
    },
    items: {
      type: Array,
    }
  }
};
</script>

<style>
</style>